import React from 'react';
// Import image directly using ES import
import waterwayImage from '../../../assets/images/waterway.jpeg';

const ChangeDetection = () => {
    return (
        <div className="analysis-section">
            <div className="analysis-content">
                <h2>Change Detection</h2>
                <p>
                    Our advanced Change Detection services leverage multi-temporal LiDAR datasets to identify, quantify, and visualize 3D changes across landscapes with millimeter-level precision. This critical capability supports applications ranging from construction monitoring to natural disaster assessment.
                </p>
                <p>
                    By comparing point clouds captured at different time intervals, we can accurately measure volumetric changes, detect structural shifts, and monitor surface deformations over time. Our sophisticated algorithms filter out noise while highlighting significant changes, providing you with actionable intelligence about landscape evolution.
                </p>
                <p>
                    From tracking coastal erosion and landslide movements to monitoring construction progress and mining operations, our change detection analysis delivers comprehensive reports with detailed metrics, heat maps, and 3D visualizations that reveal exactly where and how much change has occurred.
                </p>
                <div className="analysis-features">
                    <span className="feature-item">Volumetric Analysis</span>
                    <span className="feature-item">Deformation Monitoring</span>
                    <span className="feature-item">Construction Verification</span>
                    <span className="feature-item">Erosion Tracking</span>
                    <span className="feature-item">Temporal Comparisons</span>
                </div>
            </div>
            <div className="analysis-image">
                <img src={waterwayImage} alt="LiDAR Change Detection Analysis of Waterway Infrastructure" />
            </div>
        </div>
    );
};

export default ChangeDetection;